module.exports = __webpack_public_path__ + "img/candidates.7a2afd05.svg";